import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsClearFormatSvg } from './WpsClearFormatSvg'

export const WpsClearFormatIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsClearFormatSvg} {...props} />
}
